import React from 'react';
import PropTypes from 'prop-types';
import utils from '../../../lib/utils';

const successMessage = (business, carriers) => {
  console.log(business, carriers);
  return (
    <div>
      <p className="mindbody-success__message">
                  Thanks for authorizing TrueLark to sync with your NEXHEALTH software!
                </p>
      <p className="mindbody-success__heading">
                  Your TrueLark text-only number is:
                </p>
      <span className="mindbody-success__phone-no">
        {utils.hyphenatePhone(carriers.phoneNumber)}
      </span>
      <div className="mindbody-success__steps">
        <p className="steps">
                    Your customers can now text on this number for bookings and inquiries!
                    Please advertise this number and print it on your busniness cards.
                  </p>
        <p className="steps">
                    You must now setup your business phones to forward any calls
                    that you miss to the above text-only number.
                  </p>
      </div>
    </div>
  );
};

export default class BookerSetupSuccess extends React.Component {
  componentDidMount() {
    // Fetch text number
    this.props.getTextNumber();
  }

  render() {
    const { business, softwares, onDone, carriers } = this.props;
    const { requestStatusMessage } = softwares;
    console.log(softwares);
    return (
      <div className="booker-success">
        <span className="booker-success__user">
          Hi {business.info.FIRST_NAME || business.info.EMAIL}
        </span>
        {requestStatusMessage &&
        <p className="booker-success__message">
          {requestStatusMessage}
        </p>}
        {!requestStatusMessage&&
        <p className="booker-success__message">
         {successMessage(business, carriers)}
       </p> 
        }
        <div className="booker-success__actions">
          <button type="button" className="btn btn--primary btn--lg no-margin" onClick={onDone}>
            OK
          </button>
        </div>
      </div>
    );
  }
}

BookerSetupSuccess.propTypes = {
  onDone: PropTypes.func.isRequired,
  getTextNumber: PropTypes.func.isRequired,
  softwares: PropTypes.shape().isRequired,
  business: PropTypes.shape().isRequired,
  carriers: PropTypes.shape({
    phoneNumber: PropTypes.string,
  }).isRequired,
};
